<template>
  <v-container :class="'mt-0 pt-0 '" fluid>
    <v-card class="pa-0 ma-0 mt-6" elevation="0">
      <v-row>
        <v-col class="my-0 py-0" cols="3">
          <SelectFilter
            class="mb-0 pb-0"
            :label="this.$t('cards.banks')"
            :get-request="this.$axios.banks"
            item-text="bankName"
            item-value="bankId"
            :selectedItem="bankFilter"
            :disabled="2"
            :prepend-icon="'mdi-bank'"
            notMultiple
            v-on:changed="onChangeBankFilter"
            v-on:items="(items) => (banks = items)"
          />
        </v-col>
        <v-col class="my-0 py-0" cols="3">
          <SelcectBranchCmbxFilter
            v-model="branchFilterArray"
            :bankFilterArray="bankFilterArray"
            :disabled="!this.$store.getters.CAN_SEE_BRANCHES"
          />
        </v-col>
        <v-col class="my-0 py-0" cols="3">
          <v-text-field
            class="mb-0 pb-0"
            :label="this.$t('cards.devices')"
            :value="deviceFilter"
            @change="(v) => (deviceFilter = v)"
            :append-icon="'mdi-close'"
            @click:append="() => (deviceFilter = '')"
            :prepend-icon="'mdi-cash-register'"
          />
        </v-col>
        <v-col class="my-0 py-0" cols="2">
          <ComboboxFilter
            :get-request="this.$axios.deviceTypes"
            item-text="deviceTypeName"
            item-value="deviceType"
            :selectedItems="deviceTypesFilterArray"
            :label="this.$t('referenceBooks.devices.DeviceTypeName')"
            :prepend-icon="'mdi-alpha-t-circle-outline'"
            v-on:changed="
              (items) => {
                this.deviceTypesFilterArray = items;
              }
            "
          />
        </v-col>

        <v-col class="my-0 py-0" cols="1">
          <v-row>
            <v-spacer />
            <SearchButtons v-on:clear="clearFilters" v-on:get="getDevices" />
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="my-0 py-0" cols="3">
          <combobox-filter2000
            class="mb-0 pb-0"
            v-model="statusTypesFilterArray"
            :label="this.$t('referenceBooks.devices.Status')"
            :items="statusTypes"
            itemText="statusName"
            itemValue="deviceStatusId"
            translate
            :localizationFunc="
              (val) => $t('devicestatusNames.statusName' + val.deviceStatusId)
            "
            :prepend-icon="'mdi-clock-outline'"
            style="z-index: 200"
          />
        </v-col>
        <v-col class="my-0 py-0" cols="3">
          <v-text-field
            class="mb-0 pb-0"
            :label="this.$t('referenceBooks.devices.SN')"
            :value="serialNumberFilter"
            @change="(v) => (serialNumberFilter = v)"
            :append-icon="'mdi-close'"
            @click:append="() => (serialNumberFilter = '')"
            :prepend-icon="'mdi-alpha-n-circle-outline'"
          />
        </v-col>
        <v-col class="my-0 py-0" cols="3">
          <ComboboxFilter
            :label="this.$t('cards.products')"
            filtered
            :selectedItems="productFilterArray"
            :items-root="productsOfBanks"
            :prepend-icon="'mdi-alpha-p-circle-outline'"
            item-text="productName"
            item-value="productId"
            v-on:changed="
              (items) => {
                this.productFilterArray = items;
              }
            "
          />
        </v-col>
        <v-col class="my-0 py-0" col="7" />
      </v-row>
    </v-card>
    <v-card>
      <v-card-title class="mt-4 mb-0 pb-0 pt-2">
        {{ $t("referenceBooks.devices.Devices") }}
        <v-divider class="mx-4 " inset vertical> </v-divider>

        <DeviceDialog
          v-if="this.$store.getters.CAN_ADD_DEVICES"
          :mode="0"
          :branch="branchParam"
          :bank="bankParamModeNull"
          v-on:created="onCreated"
          v-on:error="onError"
        />
        <DeviceDialog
          v-if="this.$store.getters.CAN_EDIT_DEVICES && isActive"
          :mode="1"
          :bank="bankParamModeOne"
          :device="selectedDevice[0]"
          v-on:saved="onSaved"
        />
        <DeviceLogsDialog
          v-if="selectedDevice.length === 1"
          :device="selectedDevice[0]"
        />
        <Confirm
          v-if="this.$store.getters.CAN_DELETE_DEVICES && isActive"
          :title="deleteDeviceTitle"
          :text="confirmText"
          :tooltipText="$t('confirm.deleteDevice')"
          v-on:ok="() => onDeleteDevice(selectedDevice[0])"
          style="margin-right: 4px"
        />
        <Confirm
          v-if="this.$store.getters.CAN_DELETE_DEVICES && isNotActive"
          :disabled="this.$store.getters.CAN_DELETE_DEVICES"
          :title="restoreConfirmTitle"
          :tooltipText="$t('confirm.restoreDevice')"
          v-on:ok="onRestore"
          iconName="mdi-restore"
        />
        <PinDeviceToAnotherBranch
          v-if="isActive"
          :device="selectedDevice[0]"
          :key="pinDeviceToAnotherBranchDialogKey-1"
          @attach="onChangeBranchDevice"
          @close="() => this.pinDeviceToAnotherBranchDialogKey++"
        />

        <v-spacer />
        <v-spacer />
        <v-spacer />
        <v-spacer />
        <AttachProductsToDeviceDialog
          v-if="isActive"
          :selectedProducts="products"
          :device="selectedDevice[0]"
          :showDialogDefault="attachDialogOpened"
          :key="attachProductToDeviceDialogKey"
          @close="() => {
            attachProductToDeviceDialogKey++; 
            attachDialogOpened = false;
            isActive = false;
          }"
          v-on:attach="onAttach"
          v-on:error="onError"
        />
        <div>
          <v-tooltip bottom v-if="selectedDevice.length === 1">
            <template v-slot:activator="{ on: tooltip }">
              <v-btn
                class="mr-1"
                small
                color="primary"
                dark
                v-on="{ ...tooltip }"
                v-on:click="() => (showProductsDialog = !showProductsDialog)"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('referenceBooks.devices.ViewProducts') }}</span>
          </v-tooltip>
          <DragForm v-model="showProductsDialog">
            <v-card class="pa-0 ma-0" width="800">
              <v-card-text class="pa-0 ma-0">
                <v-container fluid class="pa-0 ma-0">
                  <v-data-table
                    fixed-header
                    :headers="productsHeaders"
                    :items="products"
                    :item-key="'productId'"
                    class="elevation-3"
                    :loading="loadingProducts"
                    :loading-text="this.$t('LoadingText')"
                    :single-select="productsSingleSelect"
                    :disable-pagination="true"
                    :no-data-text="noProductsText"
                    hide-default-footer
                    height="vh50"
                    disable-sort
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-toolbar-title
                          >{{ $t('referenceBooks.products.Products') }}
                        </v-toolbar-title>
                        <v-divider class="mx-4" inset vertical />
                        <v-spacer />
                        <v-btn
                          color="blue darken-1"
                          text
                          @click="showProductsDialog = false"
                        >
                          <v-icon> mdi-close </v-icon>
                        </v-btn>
                      </v-toolbar>
                    </template>
                    <template v-slot:item.productName="{ item }">
                      <v-row>
                        {{ item.productName }}
                        <v-tooltip v-if="item.statusId !== 1" bottom>
                          <template v-slot:activator="{ on: tooltip }">
                            <v-icon
                              class="ml-1"
                              color="red"
                              dense
                              v-on="{ ...tooltip }"
                            >
                              mdi-alert-circle-outline
                            </v-icon>
                          </template>
                          <div>
                            {{
                              $t(
                                'productStatusNames.statusName' + item.statusId
                              )
                            }}
                          </div>
                        </v-tooltip>
                      </v-row>
                    </template>
                  </v-data-table>
                </v-container>
              </v-card-text>
            </v-card>
          </DragForm>
        </div>
        <v-spacer />
        {{ $t('cards.total') }}: {{ totalCount }}
      </v-card-title>
      <LoadIcon v-if="loadingDevices" />
      <LightTable
        :headers="devicesHeaders"
        :items="devices"
        :loading="loadingDevices"
        itemKey="deviceId"
        :selectedItems="selectedDevice"
        :markedItems="changedDevicesId"
        :no-data-text="noDevicesText"
        singleSelect
        defaultSortColumn="deviceName"
        :sortBy="sortBy"
        :sortDesc="sortDesc"
        v-on:changedSortDesc="onChangeSortDesc"
        v-on:changedSort="onChangeSort"
        v-on:update="onUpdateDevices"
        :height="tableHeight"
      />
    </v-card>
  </v-container>
</template>

<script>
import DeviceDialog from '@/components/Dialogs/DeviceDialog';
import SearchButtons from '../components/FiltersComponent/SearchButtons';
import AttachProductsToDeviceDialog from '@/components/AttachProductsToDeviceDialog';
import SelectFilter from '../components/FiltersComponent/SelectFilter';
import LightTable from '@/components/Tables/LightTable';
import LoadIcon from '@/components/LoadIcon';
import Confirm from '@/components/Confirm';
import ComboboxFilter from '../components/FiltersComponent/ComboboxFilter';
import PinDeviceToAnotherBranch from '../components/PinDeviceToAnotherBranch';
import ComboboxFilter2000 from '@/components/FiltersComponent/ComboboxFilter2000';
import DragForm from '@/components/Forms/DragForm.vue';
import SelcectBranchCmbxFilter from '@/components/FiltersComponent/FinishedFilters/SelcectBranchCmbxFilter';
import Vue from 'vue';
import { notifySuccess } from '@/services/notifications';
import DeviceLogsDialog from '@/components/Dialogs/DeviceLogsDialog';
import tableHeightMixin from './mixins/tableHeightMixin';

export default {
  name: 'DevicesAndProducts',
  mixins: [tableHeightMixin],
  components: {
    DeviceLogsDialog,
    SelcectBranchCmbxFilter,
    LoadIcon,
    ComboboxFilter2000,
    DragForm,
    AttachProductsToDeviceDialog,
    LightTable,
    DeviceDialog,
    ComboboxFilter,
    SelectFilter,
    Confirm,
    SearchButtons,
    PinDeviceToAnotherBranch,
  },
  data() {
    return {
      attachProductToDeviceDialogKey: 0,
      showProductsDialog: false,
      showProducts: false,
      loadingDevices: false,
      loadingProducts: false,
      dialog: true,
      devices: [],
      selectedDevice: [],
      devicesSingleSelect: true,
      noDevices: false,
      noProducts: false,
      attachDialogOpened: false,

      // Для расчёта высоты таблицы
      offsetHeight: this.$store.getters.HEIGHT_OFFSET,
      headerH: 48,
      filterH: 112,
      tHeaderH: 32,
      tFooterH: 62,

      pinDeviceToAnotherBranchDialogKey: 0,

      deviceFilter: '',
      bankFilter: [],
      branchFilterArray: [],
      productFilterArray: [],
      deviceTypesFilterArray: [],
      statusTypesFilterArray: [],
      statusTypes: [],
      serialNumberFilter: '',

      changedDevicesId: [],

      branches: [],
      banks: [],
      productsByBanks: [],

      sortBy: [],
      sortDesc: [],
      tempDevices: [],

      limit: 10,
      totalCount: '0',
      page: 1,

      products: [],
      selectedProducts: [],
      productsSingleSelect: false,
    };
  },
  computed: {
    bankFilterArray() {
      if (
        this.bankFilter === null ||
        this.bankFilter === undefined ||
        this.bankFilter.length === 0
      )
        return [];
      else return [this.bankFilter];
    },
    isActive() {
      return (
        this.selectedDevice.length === 1 &&
        this.selectedDevice[0].deviceStatusId !== 0
      );
    },
    isNotActive() {
      return (
        this.selectedDevice.length === 1 &&
        this.selectedDevice[0].deviceStatusId === 0
      );
    },
    propertiesResponse() {
      return { Products: this.$t('errorsMessages.ProductsAttachToDevice') };
    },
    apiUri() {
      return this.$store.state.apiUri;
    },
    branchParam() {
      return this.branchFilterArray == null ||
        this.branchFilterArray.length == 0
        ? null
        : this.branchFilterArray;
    },
    bankParamModeNull() {
      return this.bankFilterArray == null || this.bankFilterArray.length == 0
        ? null
        : this.bankFilterArray[0];
    },
    bankParamModeOne() {
      try {
        const branchId = this.selectedDevice[0].branchId;
        const bankId = this.branches[branchId].bankId;

        return Object.assign({}, this.banks[bankId]);
      } catch {
        return null;
      }
    },
    branchesOfBanks() {
      if (this.bankFilterArray == null || this.bankFilterArray.length === 0)
        return null;

      return this.branches;
    },
    productsOfBanks() {
      if (this.bankFilterArray == null || this.bankFilterArray.length === 0)
        return null;

      return this.productsByBanks;
    },
    filterJson() {
      const result = {};

      result.branchesId =
        this.branchFilterArray == null || this.branchFilterArray.length == 0
          ? []
          : [this.branchFilterArray.branchId];

      result.banksId =
        this.bankFilterArray == null || this.bankFilterArray.length == 0
          ? []
          : [this.bankFilterArray[0].bankId];
      result.productsId = this.productFilterArray.map(
        (product) => product.productId
      );
      result.deviceName = !this.deviceFilter ? '' : this.deviceFilter;
      result.deviceTypesId = this.deviceTypesFilterArray.map(
        (type) => type.deviceTypeId
      );
      result.deviceStatusId = this.statusTypesFilterArray.map(
        (status) => status.deviceStatusId
      );
      result.sn = !this.serialNumberFilter ? '' : this.serialNumberFilter;

      return result;
    },
    bankIdJson() {
      let result = {};
      result =
        this.bankFilterArray == null || this.bankFilterArray.length == 0
          ? []
          : [this.bankFilterArray[0].bankId];

      return result;
    },
    deleteDeviceTitle() {
      return (
        this.$t('confirm.deleteDevice') +
        ' ' +
        this.selectedDevice[0].deviceName +
        '?'
      );
    },
    restoreConfirmTitle() {
      return (
        this.$t('confirm.restoreDevice') +
        ' ' +
        this.selectedDevice[0].deviceName +
        '?'
      );
    },
    confirmText() {
      return this.$t('confirm.text');
    },
    devicesHeaders() {
      const result = [
        { text: '', value: '0', sortable: false },
        {
          text: this.$t('referenceBooks.banks.Name'),
          value: 'bankName',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.branches.Name'),
          value: 'branchName',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.devices.Name'),
          value: 'deviceName',
          width: '300px',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.devices.DeviceTypeName'),
          value: 'deviceTypeName',
          width: '150px',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.devices.SN'),
          value: 'sn',
          width: '100px',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.devices.Link'),
          value: 'link',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.devices.Alias'),
          value: 'alias',
          sortable: true,
        },
        {
          text: this.$t('referenceBooks.products.Products'),
          value: 'productsCount',
          width: '150px',
          sortable: true,
        },
      ];
      if (this.$store.getters.RIGHTS_ON_BANK_LEVEL) result.splice(0, 1);
      if (this.$store.getters.RIGHTS_ON_BRANCH_LEVEL) result.splice(0, 2);

      return result;
    },
    productsHeaders() {
      const result = [
        { text: '', value: '0', sortable: false },
        {
          text: this.$t('referenceBooks.banks.Name'),
          value: 'bankName',
          sortable: false,
        },
        {
          text: this.$t('referenceBooks.products.Name'),
          value: 'productName',
          sortable: false,
        },
        {
          text: this.$t('referenceBooks.products.Link'),
          value: 'link',
          sortable: false,
        },
        {
          text: this.$t('referenceBooks.products.Alias'),
          value: 'alias',
          sortable: false,
        },
        {
          text: this.$t('referenceBooks.Hopper'),
          value: 'hopper',
          sortable: false,
        },
      ];
      if (
        this.$store.getters.RIGHTS_ON_BANK_LEVEL ||
        this.$store.getters.RIGHTS_ON_BRANCH_LEVEL
      )
        result.splice(0, 1);

      return result;
    },
    noDevicesText() {
      return this.$t('cards.noData');
    },
    noProductsText() {
      return this.noProducts
        ? this.$t('cards.noData')
        : this.$t('referenceBooks.devices.ChooseSomeDevice');
    },
  },
  watch: {
    filterJson() {
      this.getDevices();
    },
    branchFilterArray() {
      if (this.branchFilterArray && this.branchFilterArray.length !== 0) {
        var bank = this.banks.find(
          (bankItem) => this.branchFilterArray.bankId === bankItem.bankId
        );
        this.bankFilter = bank;
      }
    },
    deviceTypesFilterArray() {
      if (
        this.statusTypesFilterArray === null ||
        this.statusTypesFilterArray.length === 0
      )
        this.setActiveStatusesForFilter();
    },
    dialog(val) {
      val || this.close();
    },
    selectedDevice() {
      this.products = [];
      if (this.selectedDevice !== null && this.selectedDevice.length > 0)
        this.loadProducts(this.selectedDevice[0]);
      this.pinDeviceToAnotherBranchDialogKey++;
      this.attachProductToDeviceDialogKey++;
    },
  },
  async mounted() {
    await this.$axios.statusTypes
      .get()
      .then((response) => response.data)
      .then((json) => {
        this.statusTypes = json;
      })
      .catch((error) => {
        console.error(error);
      });
    this.setActiveStatusesForFilter();
    this.getDevices();
  },

  methods: {
    setActiveStatusesForFilter() {
      this.statusTypesFilterArray = this.statusTypes.filter(
        (val) => val.deviceStatusId !== 0
      );
    },
    onChangeBranchDevice(status, deviceId) {
      this.getDevices();
      this.markRow(deviceId);
    },
    onUpdateDevices(items) {
      this.selectedDevice = items;
      this.changedDevicesId = [];
    },
    onChangeBankFilter(items) {
      this.bankFilter = items;
      this.getProducts();
    },
    async getBranches() {
      if (this.bankFilterArray == null || this.bankFilterArray.length === 0) {
        this.branches = null;
        this.branchesFlag = null;

        return;
      }
      await this.$axios.branches
        .getByBanksArrayForDevices(this.bankIdJson)
        .then((response) => response.data)
        .then((json) => {
          this.branches = json;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async getProducts() {
      this.productFilterArray = [];
      if (this.bankFilterArray == null || this.bankFilterArray.length === 0) {
        this.productsByBanks = null;

        return;
      }

      await this.$axios.products
        .getByBanksArrayForDevices(this.bankIdJson)
        .then((response) => response.data)
        .then((json) => {
          this.productsByBanks = json;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async onDeleteDevice(device) {
      await this.$axios.devices
        .delete(device.deviceId)
        .then(() => {
          notifySuccess(
            '',
            this.$t('Messages.DeviceWasDeleted', [device.deviceName])
          );
          this.getDevices();
        })
        .catch((error) => {
          this.catchError(error, '', this.$t('errorsMessages.Delete'));
        });
    },
    async onRestore() {
      const val = this.selectedDevice[0];
      await this.$axios.devices
        .restore(val.deviceId)
        .then((response) => {
          if (response.status == 200) {
            notifySuccess(
              '',
              this.$t('Messages.DeviceWasRestored', [val.deviceName])
            );
          } else
            this.showMessage(
              this.$t('Restored'),
              `${this.$t('referenceBooks.devices.Name')}: ${
                val.deviceName
              }\n${this.$t('Status')}: ${response.status}`,
              'warn'
            );
          this.getDevices();
        })
        .catch((error) => {
          console.error(error);
          this.catchError(
            error,
            val.deviceName,
            this.$t('errorsMessages.Restore')
          );
        });
    },
    catchError(error, name, errorHeader = '') {
      console.error(error);
      const status = error.response.status;
      const data = [error.response.data];

      const errorHeaderActual =
        errorHeader === '' ? this.$t('Error') : errorHeader;
      if (status === 400 || status === 401) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].errorType === 'HAS_RELATIONS') {
            this.showMessage(
              `${errorHeaderActual}`,
              `${this.propertiesResponse[data[i].property]} ${name}`,
              'error'
            );
          } else if (data[i].errorType === 'NO_RIGHTS') {
            this.showMessage(
              `${errorHeaderActual}`,
              `${this.$t('errorsMessages.NoRights')}`,
              'error'
            );
          } else this.showMessage(errorHeaderActual, error, 'error');
        }
      } else {
        this.showMessage(errorHeaderActual, error, 'error');
      }
    },
    onAttach(status, deviceId) {
      const lastDevice = this.selectedDevice[0];

      this.markRow(deviceId);
      this.getDevices();
      this.selectedDevice[0] = lastDevice;
      this.loadProducts(this.selectedDevice[0]);
    },
    checkFilters() {
      return (
        (this.bankFilterArray == null || this.bankFilterArray.length == 0) &&
        (this.branchFilterArray == null ||
          this.branchFilterArray.length == 0) &&
        (this.productFilterArray == null ||
          this.productFilterArray.length == 0) &&
        (this.deviceFilter == null || this.deviceFilter.length == 0)
      );
    },
    clearFiltersOnSave() {
      this.productFilterArray = [];
      this.deviceFilter = '';
    },
    clearFilters() {
      if (this.banks.length > 1) {
        this.bankFilter = [];
        this.branchFilterArray = [];
      } else if (this.banks.length === 1 && this.branches.length > 1) {
        this.branchFilterArray = [];
      }

      this.productFilterArray = [];
      this.deviceFilter = '';
      (this.deviceTypesFilterArray = []), (this.statusTypesFilterArray = []);
      (this.serialNumberFilter = ''), this.getDevices();
    },
    async getDevices(selectedIds) {
      this.loadingDevices = true;
      this.selectedDevice = [];
      const params = {
        query: JSON.stringify(this.filterJson),
      };
      this.getCount(params);
      params.limit = await this.limit;
      params.offset = (await this.limit) * (this.page - 1);
      this.executeRequest(params, selectedIds);
    },
    async getCount(params) {
      this.$axios.devices
        .getCount(params)
        .then((response) => response.data)
        .then((json) => {
          this.paginationLength = Math.ceil(json.totalCount / this.limit);
          this.totalCount = json.totalCount;
        })
        .catch((error) => {
          this.onError(error, this.$t('referenceBooks.devices.GetFailedCount'));
        });
    },
    async executeRequest(params, selectedIds) {
      this.$axios.devices
        .get(params)
        .then((response) => response.data)
        .then((json) => {
          this.tempDevices = this.sortData(json, this.sortBy, this.sortDesc);
          this.devices = this.tempDevices.slice(0, 500);
          this.loadingDevices = false;
          this.noDevices = this.devices == null || this.devices.length == 0;
          if (selectedIds) {
            // используем, чтобы сразу при создании девайса выбрать его
            // и открыть окно привязки продуктов
            this.selectedDevice = this.devices.filter((item) =>
              selectedIds.includes(item.deviceId)
            );
            // сразу открываем модалку
            this.attachDialogOpened = true;
          }
        })
        .catch((error) => {
          this.loadingDevices = false;
          this.onError(error, this.$t('referenceBooks.devices.GetFailed'));
        });
    },
    onChangeSort(sort) {
      this.sortBy = sort;

      if (this.sortDesc.length === this.sortBy.length)
        this.devices = this.sortData(
          this.tempDevices,
          this.sortBy,
          this.sortDesc
        ).slice(0, 500);
    },
    onChangeSortDesc(sortDesc) {
      this.sortDesc = sortDesc;

      if (this.sortDesc.length === this.sortBy.length)
        this.devices = this.sortData(
          this.tempDevices,
          this.sortBy,
          this.sortDesc
        ).slice(0, 500);
    },
    sortData(items, sortBy, desc) {
      items.sort(function (a, b) {
        let index = 0;

        while (index < sortBy.length) {
          const isDesc =
            desc !== null && desc[index] !== null && desc[index] === true
              ? true
              : false;

          if (a[sortBy[index]] === null && b[sortBy[index]] === null) return 0;
          if (a[sortBy[index]] === null) return isDesc ? -1 : 1;
          if (b[sortBy[index]] === null) return isDesc ? 1 : -1;

          if (a[sortBy[index]] > b[sortBy[index]]) return isDesc ? -1 : 1;
          if (a[sortBy[index]] < b[sortBy[index]]) return isDesc ? 1 : -1;
          index++;
        }

        return 0;
      });

      return items;
    },
    setDefaultSort() {
      const resultSort = ['bankName', 'branchName', 'deviceName'];

      if (this.$store.getters.RIGHTS_ON_BANK_LEVEL) resultSort.splice(0, 1);
      if (this.$store.getters.RIGHTS_ON_BRANCH_LEVEL) resultSort.splice(0, 2);

      const resultDesc = [];
      for (let i = 0; i < resultSort.length; i++) resultDesc.push(false);

      this.sortBy = resultSort;
      this.sortDesc = resultDesc;
    },
    deviceSelected(item) {
      if (!item.value) this.selectedProducts = [];
    },
    loadProducts(device) {
      this.loadingProducts = true;
      this.$axios.products
        .getFromDevice(device.deviceId)
        .then((response) => response.data)
        .then((json) => {
          this.products = json;
          this.loadingProducts = false;
          this.noProducts = this.products == null || this.products.length == 0;
        })
        .catch((error) => {
          this.loadingProducts = false;
          console.error(error);
          this.showMessage(
            this.$t('referenceBooks.products.Failed'),
            error,
            'error'
          );
        });
    },
    markRow(id) {
      this.changedDevicesId = [];
      this.changedDevicesId.push(id);
    },
    onSaved(status, device) {
      this.clearFiltersOnSave();
      this.getDevices();

      if (status == 200)
        this.showMessage(
          this.$t('referenceBooks.devices.Saved'),
          `${this.$t('referenceBooks.devices.Name')}: ${device.deviceName}`
        );
      else
        this.showMessage(
          this.$t('referenceBooks.devices.Saved'),
          `${this.$t('referenceBooks.devices.Name')}: ${device.deviceName}`,
          'warn'
        );

      this.markRow(device.deviceId);
    },
    onCreated(status, deviceName, id, attachProductsFlag) {
      this.getDevices(attachProductsFlag ? [id] : undefined);
      if (status == 200)
        this.showMessage(
          this.$t('referenceBooks.devices.created'),
          `${this.$t('referenceBooks.devices.Name')}: ${deviceName}`
        );
      else
        this.showMessage(
          this.$t('referenceBooks.devices.created'),
          `${this.$t('referenceBooks.devices.Name')}: ${deviceName}`,
          'warn'
        );

      this.markRow(id);
    },
    async onError(error, errorHeader = '') {
      this.catchError(error, null, errorHeader);
    },
    showMessage(title, text, type = '') {
      Vue.notify({
        group: 'notif',
        title: title,
        text: text,
        type: type,
      });
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
  },
};
</script>
